import { FILE_TYPE_PNG, MAX_PNG_SIZE } from '@constants/global';

export const isLargePng = async (type: string, fileEl: { src: string; file: File }) => {
  const isPng = type.includes(FILE_TYPE_PNG);
  if (!isPng) return false;
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.src = fileEl.src;

    img.onload = () => {
      const fileWidth = img.width;
      const isBiggerSize = fileWidth > MAX_PNG_SIZE;
      resolve(isBiggerSize);
    };

    img.onerror = () => {
      resolve(reject);
    };
  });
};
